import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Injector, Input, Output } from '@angular/core';
import { DsFormFieldModule } from '@bmw-ds/components';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessor } from '../../value-accessor/value-accessor';
import { NgIf } from '@angular/common';

@Component({
    selector: 'density-input-text-area',
    imports: [DsFormFieldModule, TranslateModule, NgIf, FormsModule],
    templateUrl: './density-input-text-area.component.html',
    styleUrl: './density-input-text-area.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DensityInputTextAreaComponent),
            multi: true
        }
    ]
})
export class DensityInputTextAreaComponent extends ValueAccessor<string> {
    private static nextId = 0;

    @Input()
    inputId: string = `density-textarea-${DensityInputTextAreaComponent.nextId++}`;

    @Input()
    disabled: boolean = false;

    @Input()
    readOnly: boolean = false;

    @Input()
    required: boolean = true;

    @Input()
    label: string = '';

    @Input()
    placeholder: string = '';

    @Input()
    charLimit: number = 0;

    @Input()
    autoSize: boolean = false;

    @Output()
    valueChanged = new EventEmitter<string>();

    @Output()
    blurEvent = new EventEmitter<void>();

    constructor(injector: Injector) {
        super(injector);
    }
}
